module.exports = __webpack_public_path__ + "static/media/profile.4ba68486.svg";